import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { localizedSlug } from "@/lib/utils";
import { MaskWords } from "@/components/site/primitives";
import { Reveal } from "@/components/site/Reveal";

export default function JournalIndex() {
  const { lang, t } = useLang();
  const j = t.journal;
  const [essays, setEssays] = useState(null);

  useEffect(() => {
    api.get("/essays").then((r) => setEssays(r.data)).catch(() => setEssays([]));
  }, []);

  const g = (e, k) => e[`${k}_${lang}`] || e[`${k}_ro`] || "";

  return (
    <div className="bg-paper text-ink min-h-screen">
      <section className="px-6 md:px-12 lg:px-20 pt-36 md:pt-48 pb-14 md:pb-20">
        <div className="eyebrow text-ink/50 mb-6">{j.label}</div>
        <MaskWords Tag="h1" text={j.title} className="display uppercase text-[15vw] md:text-[16vw] lg:text-[13vw] leading-[0.82] break-words" />
        <p className="mt-8 text-lg md:text-xl leading-[1.55] text-ink/70 max-w-2xl">{j.intro}</p>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-32 md:pb-44">
        <div className="border-t border-ink/15">
          {(essays || []).map((e, i) => (
            <Reveal key={e.id}>
              <Link
                to={`/journal/${localizedSlug(e, lang)}`}
                data-testid={`essay-link-${e.slug}`}
                data-cursor="link"
                className="group grid grid-cols-12 gap-6 py-9 md:py-12 border-b border-ink/15 items-baseline"
              >
                <div className="col-span-12 lg:col-span-2 eyebrow text-ink/45 flex justify-between lg:block">
                  <span>{g(e, "category")}</span>
                  <span className="tnum">{e.reading_time}</span>
                </div>
                <h2 className="col-span-12 lg:col-span-7 serif text-4xl md:text-6xl leading-[1.0] transition-transform duration-500 group-hover:translate-x-2">
                  {g(e, "title")}
                </h2>
                <p className="col-span-12 lg:col-span-3 text-ink/65 leading-[1.55] flex items-end justify-between gap-4">
                  <span className="line-clamp-3">{g(e, "excerpt")}</span>
                  <ArrowRight size={22} className="shrink-0 opacity-0 -translate-x-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0" />
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
        {essays === null && <div className="eyebrow text-ink/40 py-10">{j.loading}</div>}
        {essays && essays.length === 0 && <div className="eyebrow text-ink/40 py-10">{j.empty}</div>}
      </section>
    </div>
  );
}
